import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SessionStore } from './session.store';
import { tap } from 'rxjs/operators';
import { LoginReq } from '@ogn-tracker/common/build/auth';
import { LoginResponse } from '@ogn-tracker/common/build/login';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { resetStores } from '@datorama/akita';

@Injectable({ providedIn: 'root' })
export class SessionService {
  url = environment.api + '/api';

  constructor(private sessionStore: SessionStore, private http: HttpClient) {}

  getToken(): string {
    return this.sessionStore.getValue().token;
  }

  login(body: LoginReq): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(this.url + '/login', body).pipe(
      tap((response) => {
        localStorage.setItem('token', response.token);
        this.sessionStore.update((state) => {
          return { ...state, token: response.token };
        });
      })
    );
  }

  logout(): void {
    resetStores();
    localStorage.clear();
  }
}
